import AppRoute from "models/AppRoute"

const CustomerOverviewRoute = new AppRoute({
    route: "/customers",
    navbar: true,
    authRequired: true,
})

export default CustomerOverviewRoute
